import React from "react";
import styles from "./styles/Mechatronics.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import MechatronicsHero from "./MechatronicsHero";
import MechatronicsProducts from "./MechatronicsProducts";
import MechatronicsCTA from "./MechatronicsCTA";

export default function Mechatronics() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <MechatronicsHero />
        <MechatronicsProducts />
        <MechatronicsCTA />
      </main>
      <Footer />
    </div>
  );
}
